(function () {
  function forceCanada() {
    document.querySelectorAll('input[type="tel"]').forEach((input) => {
      // intl-tel-input stores its instance here in many builds
      if (input._intlTelInput && typeof input._intlTelInput.setCountry === 'function') {
        input._intlTelInput.setCountry('ca');
      }
    });
  }

  // Run now + shortly after load
  forceCanada();
  setTimeout(forceCanada, 500);
  setTimeout(forceCanada, 1500);

  // Watch for Tipo popup injecting new DOM
  const obs = new MutationObserver(() => forceCanada());
  obs.observe(document.body, { childList: true, subtree: true });
})();
